import { Operation, OperationIds } from '../types';

export const DATE_FORMAT = 'dd/MM/yyyy';
export const TIME_FORMAT = 'h:mm aaa';
export const DATETIME_FORMAT = `${DATE_FORMAT}; ${TIME_FORMAT}`;

export const OPERATIONS = [
	{ order: 0, id: OperationIds.Matches, name: Operation.Matches },
	{ order: 1, id: OperationIds.Equals, name: Operation.Equals },
	{ order: 2, id: OperationIds.Contains, name: Operation.Contains },
	{ order: 3, id: OperationIds.StartsWith, name: Operation.StartsWith },
	{ order: 4, id: OperationIds.EndsWith, name: Operation.EndsWith },
	{ order: 5, id: OperationIds.ContainsKey, name: Operation.ContainsKey },
	{ order: 6, id: OperationIds.ContainsValue, name: Operation.ContainsValue },
	{ order: 7, id: OperationIds.GreaterThan, name: Operation.GreaterThan },
	{ order: 8, id: OperationIds.LessThan, name: Operation.LessThan },
	{ order: 9, id: OperationIds.IsEmpty, name: Operation.IsEmpty },
	{
		order: 10,
		id: OperationIds.EqualsIgnoreWhitespace,
		name: Operation.EqualsIgnoreWhitespace,
	},
] as const;

export const SPOTLIGHT_NAMES = {
	dndTitle: 'eoc-notifications_dnd_title',
	rulesTitle: 'eoc-notifications_rules_title',
	forwardingRulesTitle: 'eoc-notifications_forwarding_rules_title',
};

export const defaultTimes = [...Array(24).keys()]
	.map((time) => {
		let newTime = time.toString();
		if (newTime.length === 1) {
			newTime = `0${time}`;
		}
		return [`${newTime}:00`, `${newTime}:30`];
	})
	.flatMap((time) => time);

export const supportArticles = {
	setUpRoleBasedNotifications: {
		jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-role-based-notifications/',
		compass:
			'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/112066569/Set+up+role-based+notifications/',
	},
	setUpSmsAndVoice: {
		jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-sms-and-voice-notifications/#Contact-information',
		compass:
			'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404235/Set+up+SMS+and+voice+notifications#Contact-information',
	},
	setUpNotificationPreferences: {
		jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/set-up-notification-preferences',
		compass:
			'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11469955/Set+up+notification+preferences',
	},
	notificationForwardingRules: {
		jsm: 'https://support.atlassian.com/jira-service-management-cloud/docs/add-notification-forwarding-rules',
		compass:
			'https://compass-ops-help.atlassian.net/wiki/spaces/OPERATIONS/pages/11404196/Add+notification+forwarding+rules',
	},
};
